( function () {
	const nav = document.querySelector( '.facility-details__nav' );
	if ( !nav ) { return; }

	// ALL anchor links on the page that are more than just #
	const unfilteredLinks = Array.from( document.querySelectorAll( 'a[href^="#"]:not([href="#"])' ) ) || [];
	let links = [], sections = [], anchorTargets = [];
	unfilteredLinks.forEach( ( link ) => {
		let target;
		try {
			target = document.querySelector( link.getAttribute( 'href' ) );
		} catch( err ) { target = null; }
		
		if( target ) {
			if( nav.contains( link ) ) {
				// one of this nav's target sections
				links.push( link );
				sections.push( target );
			} else {
				// not one of the nav's sections, but another on the page which to be offset from under the sticky nav
				anchorTargets.push( target );
			}
		}
	} );

	const navbar = document.querySelector( '.navbar' );
	const stickyNavbar = navbar && navbar.querySelector( '.navbar__primary' );
	let navbarHeight = 0;
	let debounceTimer;
	const ACTIVE_OFFSET = .1; // mostly up the viewport (1 is at the bottom, 0 is at the top)

	navbar.addEventListener( 'navbarChanged', recalculateNavHeight );
	window.addEventListener( 'resize', debounce, { passive: true } );
	window.addEventListener( 'scroll', doRecalculations, { passive: true } ); // no debounce to make the active section change smoother

	doRecalculations();

	function debounce() {
		clearTimeout( debounceTimer );
		debounceTimer = setTimeout( doRecalculations, 100 );
	}

	function doRecalculations() {
		recalculateNavHeight(); // Recalculate navbar height, it changes size on scroll when it sticks
		updateActiveSection();
	}

	function recalculateNavHeight() {
		if( stickyNavbar ) {
			let isSticky = navbar.classList.contains( 'navbar--pinned' );
			// it will be sticky by the time we've scrolled down to it - get the height ahead of then
			if( !isSticky ) { navbar.classList.add( 'navbar--pinned' ); }

			navbarHeight = stickyNavbar.offsetHeight;

			if( !isSticky ) {
				navbar.classList.remove( 'navbar--pinned' );
			}
		} else {
			navbarHeight = 0;
		}

		nav.style.top = navbarHeight + 'px';

		Array.from( sections ).concat( Array.from( anchorTargets ) ).forEach( function ( target ) {
			target.style.scrollMarginTop = ( navbarHeight + nav.offsetHeight ) + 'px';
		} );
	}

	// Highlight active link as you scroll
	function updateActiveSection () {
		const scrollY = window.scrollY || window.pageYOffset;
		const viewportHeight = window.innerHeight;
		let activeIndex = 0; // first one is active by default

		sections.forEach( function ( section, i ) {
			const rect = section.getBoundingClientRect();
			const sectionTop = rect.top + scrollY;

			if( scrollY + navbarHeight + nav.offsetHeight >= sectionTop - viewportHeight * ACTIVE_OFFSET ) {
				// top of this section is at or above the offset point
				activeIndex = i;
			}
		} );

		links.forEach( function ( link, i ) {
			if ( i === activeIndex ) {
				link.classList.add( 'facility-details__nav-link--active' );
				link.scrollIntoView( { behavior: 'smooth', inline: 'center', block: 'nearest' } );
			} else {
				link.classList.remove( 'facility-details__nav-link--active' );
			}
		} );
	}
} )();
